/**
 * @generated SignedSource<<6d7cd92bb1d63db60fa1b9750cc4482a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: nx generate-api-types
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UkRiskWarningInfoQuery$variables = {
  identifier: string;
};
export type UkRiskWarningInfoQuery$data = {
  readonly ukRiskWarning: {
    readonly acceptLabel: string | null | undefined;
    readonly body: string;
    readonly headline: string | null | undefined;
    readonly identifier: string;
    readonly linkText: string | null | undefined;
    readonly linkUrl: string | null | undefined;
    readonly rejectLabel: string | null | undefined;
  } | null | undefined;
};
export type UkRiskWarningInfoQuery = {
  response: UkRiskWarningInfoQuery$data;
  variables: UkRiskWarningInfoQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "identifier"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "identifier",
        "variableName": "identifier"
      }
    ],
    "concreteType": "UKRiskWarning",
    "kind": "LinkedField",
    "name": "ukRiskWarning",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "identifier",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "headline",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "body",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "linkUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "linkText",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "acceptLabel",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "rejectLabel",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UkRiskWarningInfoQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UkRiskWarningInfoQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9b458cc0ea654f0c72216fc10c3bbc13",
    "id": null,
    "metadata": {},
    "name": "UkRiskWarningInfoQuery",
    "operationKind": "query",
    "text": "query UkRiskWarningInfoQuery(\n  $identifier: String!\n) {\n  ukRiskWarning(identifier: $identifier) {\n    identifier\n    headline\n    body\n    linkUrl\n    linkText\n    acceptLabel\n    rejectLabel\n  }\n}\n"
  }
};
})();

(node as any).hash = "d327b8d599b72bcf9d50d192b36112f1";

export default node;
